export default "__VITE_ASSET__CdbOOWqC__"